import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { Utils } from "../../helper/utils.helper";
import { User } from "../../models/user.model";
import { PermissionCheck } from "../../shared/permission";
import { DefaultDialogs } from "../../helper/default-dialogs.helper";

let FeatureDisabledDialogComponent = {
    selector: "vcFeatureDisabledDialog",
    templateUrl:
        "/angular/components/feature/feature-disabled-dialog.component.html",
    bindings: {
        title: "=?",
        body: "=?",
        essentials: "=?",
    },
    controller: class FeatureDisabledDialogController {
        // * bindings for typescript compiler *
        public title: string;
        public body: string;
        public essentials: boolean;
        // ************************************

        private readonly $scope: any;
        private dialog: DialogUtils;
        private defaultDialogs: DefaultDialogs;
        private permissionProvider: PermissionCheck;
        public utils: Utils;
        public confirmButtonText: string;
        public svgSrc: string;

        constructor(
            $scope: any,
            DialogUtils: DialogUtils,
            Utils: Utils,
            PermissionCheck: PermissionCheck,
            DefaultDialogs: DefaultDialogs
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.utils = Utils;
            this.permissionProvider = PermissionCheck;
            this.defaultDialogs = DefaultDialogs;
        }

        $onInit() {
            if (this.essentials) {
                this.title =
                    this.title ??
                    "This feature disabled while your subscription is paused";
                this.body =
                    this.body ??
                    "We're sorry to say this feature is not available during paused subscription. If you would like to use this feature, please resume subscription";
                this.confirmButtonText = "Resume Subscription";
                this.svgSrc = "/img/icons/new/pause.svg";
            } else {
                this.title = this.title ?? "This feature is not available";
                this.body =
                    this.body ??
                    "We're sorry to say this feature is not available during the trial period. To use this feature now, please contact our support team.";
                this.confirmButtonText = "Contact Support";
                this.svgSrc = "/img/icons/new/privacy-by-design.svg";
            }
        }

        confirmClicked(ev: any): void {
            if (this.essentials) {
                if (this.permissionProvider.hasStripeSubscription) {
                    this.dialog.show({
                        component: "vc-upgrade-plan-dialog",
                        targetEvent: ev,
                        scope: this.$scope,
                        locals: {
                            conversionType: "change",
                        },
                        fullscreen: true,
                        forceFullscreen: true,
                        size: "xx-large",
                        style: "background: #f6f6f6",
                    });
                } else {
                    this.defaultDialogs.contactSupport(
                        "Upgrade subscription",
                        "creating additional accounts",
                        ev
                    );
                }
            } else {
                this.utils.openSupport(ev);
            }
        }

        dismiss(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("feature")
    .component(
        FeatureDisabledDialogComponent.selector,
        FeatureDisabledDialogComponent
    );
